<template>
    <v-container fill-height fluid grid-list-xl class="pt-0">
        <v-layout wrap>
            <v-flex xs12 class="pt-0">
                <material-card color="green" title="Logs">
                    <v-data-table
                        :headers="headers"
                        :items="logs"
                        v-bind:pagination.sync="pagination"
                        hide-actions
                        disable-initial-sort
                    >
                        <template slot="headerCell" slot-scope="{ header }">
                            <span
                                class="font-weight-light text-success text--darken-3"
                                v-text="header.text"
                            />
                        </template>
                        <template slot="items" slot-scope="{ index, item }">
                            <tr
                                @click="viewDetails(item)"
                                style="cursor: pointer;"
                            >
                                <td>
                                    <v-tooltip top dark>
                                        <template #activator="{ on }" dark>
                                            <v-icon
                                                v-on="on"
                                                dark
                                                :color="
                                                    getTypeIconColor(item.Type)
                                                "
                                                >{{
                                                    getTypeIcon(item.Type)
                                                }}</v-icon
                                            >
                                        </template>
                                        <span dark>{{ item.Type }}</span>
                                    </v-tooltip>
                                </td>
                                <td class="text-xs-left font-weight-regular">
                                    {{ item.LastUpdated }}
                                </td>
                                <td class="text-xs-left font-weight-regular">
                                    {{ item.SenderName }}
                                </td>
                                <td class="text-xs-left font-weight-regular">
                                    {{ item.SenderPhone }}
                                </td>
                                <td class="text-xs-left font-weight-regular">
                                    {{ item.number }}
                                </td>
                                <td class="text-xs-left font-weight-regular">
                                    {{ item.listenerCount }}
                                </td>
                                <td
                                    class="text-xs-left font-weight-regular"
                                    style="min-width: 300px"
                                >
                                    {{ item.listeners }}
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <div class="text-xs-center mt-2">
                        <v-pagination
                            v-model="pagination.page"
                            :length="pages"
                            :total-visible="5"
                        ></v-pagination>
                    </div>
                </material-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="viewLogDialog" max-width="550">
            <v-card class="p-2">
                <v-card-title class="headline">Log Details</v-card-title>
                <v-card-text class="mb-3">
                    <v-layout row>
                        <v-layout column>
                            <v-layout row>
                                <div class="font-weight-medium mb-2 mr-1">
                                    Type:
                                </div>
                                {{ clickedLog.Type }}
                            </v-layout>
                            <v-layout row>
                                <div class="font-weight-medium mb-2 mr-1">
                                    Number:
                                </div>
                                {{ clickedLog.number }}
                            </v-layout>
                        </v-layout>
                        <v-spacer></v-spacer>
                        <div>
                            <v-layout row class="mb-2">
                                <div class="font-weight-medium mr-2 mr-1">
                                    Last Updated:
                                </div>
                                <div>
                                    {{ formatTime(clickedLog.LastUpdated) }}
                                </div>
                            </v-layout>
                            <!-- <v-layout row class="mb-2">
                                <div class="font-weight-medium mr-2 mr-1">
                                    Calls Loaded:
                                </div>
                                <div>
                                    {{ calls.length }}
                                </div>
                            </v-layout> -->
                        </div>
                    </v-layout>
                    <v-progress-linear
                        v-if="loading"
                        :indeterminate="true"
                        color="success"
                        style="width: 70%;"
                        class="mx-1"
                    ></v-progress-linear>
                    <div class="mt-3" v-if="!loading">
                        <v-divider class="mb-2"></v-divider>
                        <div
                            v-for="(info, index) in clickedLog.listenerInfoSql"
                        >
                            <v-layout row>
                                <div
                                    style="width: 175px"
                                    class="font-weight-medium"
                                >
                                    {{ info.name }}
                                </div>
                                <div style="width: 100px">{{ info.time }}</div>
                                <div>
                                    {{ formatTime(info.lastTime) }}
                                </div> </v-layout
                            ><v-divider
                                class="mb-2 mt-1"
                                v-if="
                                    index + 1 <
                                        clickedLog.listenerInfoSql.length
                                "
                            ></v-divider>
                        </div>
                        <v-divider class="mt-2"></v-divider>
                    </div>
                </v-card-text>
                <v-list>
                    <div v-for="(hit, index) in clickedLog.Hits">
                        <v-list-tile class="row-height mt-3 mb-4">
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    <div>
                                        {{ formatTime(hit.Timestamp) }}
                                    </div>
                                </v-list-tile-title>
                                <div class="font-weight-medium">
                                    {{
                                        hit.Name
                                            ? hit.Name
                                            : formatPhoneNumber(hit.CallerID)
                                    }}
                                </div>
                            </v-list-tile-content>
                            <v-spacer></v-spacer>
                            <v-list-tile-action style="height: 90px;">
                                <v-list-tile-title class="text-xs-right mt-1"
                                    >{{ "Track #" + hit.TrackNumber }}
                                </v-list-tile-title>
                                <audio
                                    style="height: 33px;"
                                    class="mt-2"
                                    controls
                                    :src="hit.Recording"
                                    ref="recording"
                                ></audio>
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-divider
                            v-if="index + 1 < clickedLog.Hits.length"
                        ></v-divider>
                    </div>
                </v-list>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="mb-2"
                        @click="viewLogDialog = false"
                        color="#999"
                        dark
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import ky from "ky";
import * as firebase from "firebase/app";
import "firebase/database";
import moment from "moment";

export default {
    data() {
        return {
            rowsPerPageItems: [10, 20],
            pagination: {
                totalItems: 0,
                rowsPerPage: 20,
                page: 1,
            },
            loading: false,

            headers: [
                { value: "Type", text: "Type" },
                { value: "LastUpdated", text: "Last Updated" },
                { value: "SenderName", text: "Name" },
                { value: "SenderPhone", text: "From Phone" },
                { value: "number", text: "Number" },
                { value: "listenerCount", text: "Listeners" },
                { value: "listeners", text: "Listener Names" },
            ],

            logs: [],
            calls: [],

            clickedLog: "",
            viewLogDialog: false,
        };
    },
    computed: {
        pages() {
            return this.pagination.rowsPerPage
                ? Math.ceil(
                      this.pagination.totalItems / this.pagination.rowsPerPage,
                  )
                : 0;
        },
    },
    filters: {
        pretty: function(value) {
            if (!value) return "";

            return JSON.stringify(value, null, 2);
        },
    },
    created() {
        this.firebaseSetup();
    },
    methods: {
        firebaseSetup() {
            const firebaseConfig = {
                apiKey: "Xs6kU5UjjL8n5LdLQJMGnWcaEietBLrj5U9FnpIb",
                authDomain: "broadcast-b7a56.firebaseapp.com",
                databaseURL: "https://broadcast-b7a56.firebaseio.com",
                projectId: "broadcast-b7a56",
            };

            // Initialize Firebase
            if (!firebase.apps.length) {
                firebase.initializeApp(firebaseConfig);
            }

            var database = firebase.database();
            var ref = firebase.database().ref("logs");

            const logsRef = ref.orderByKey().limitToLast(300);

            logsRef.on(
                "value",
                (snapshot) => {
                    this.setupLogs(snapshot);
                },
                function(error) {
                    console.log("Error: " + error.code);
                },
            );

            this.loadCalls(
                moment()
                    .subtract(3, "months")
                    .format("yyyy-MM-DDThh:mm:ss"),
                moment()
                    .add(1, "days")
                    .format("yyyy-MM-DDThh:mm:ss"),
            );
        },
        loadCalls(start, end) {
            return firebase
                .database()
                .ref()
                .child("calls")
                .orderByChild("Timestamp")
                .startAt(start)
                .endAt(end)
                .on(
                    "value",
                    (snapshot) => {
                        this.calls = Object.values(snapshot.val()).map(
                            (call) => {
                                return call;
                            },
                        );
                    },
                    function(error) {
                        console.log("Error: " + error.code);
                    },
                );
        },
        setupLogs(snapshot) {
            const logs = Object.values(snapshot.val()).map((log) => {
                log.number = log.InterviewNumber
                    ? log.InterviewNumber
                    : log.TalkNumber
                    ? log.TalkNumber
                    : log.MessageDate;

                if (log.State) {
                    log.number = log.State;
                }

                log.LastUpdated = this.formatTime(log.LastUpdated);
                log.SenderPhone = this.formatPhoneNumber(log.SenderPhone);

                log.Hits = log.Hits.map((h) => {
                    h.Name = h.Name
                        ? h.Name
                        : this.formatPhoneNumber(h.CallerID);
                    return h;
                });

                log.listenerCount = log.Hits.filter((l) => l.Name)
                    .map((l) => l.Name)
                    .filter(this.onlyUnique).length;
                log.listeners = log.Hits.filter((l) => l.Name)
                    .map((l) => l.Name)
                    .filter(this.onlyUnique)
                    .join(", ");

                this.setupListnerInfo(log);

                log.Hits = log.Hits.sort((a, b) => {
                    if (Date.parse(a.Timestamp) > Date.parse(b.Timestamp))
                        return -1;
                    if (Date.parse(a.Timestamp) < Date.parse(b.Timestamp))
                        return 1;
                    return 0;
                });

                return log;
            });
            this.logs = logs.sort((a, b) => {
                if (Date.parse(a.LastUpdated) > Date.parse(b.LastUpdated))
                    return -1;
                if (Date.parse(a.LastUpdated) < Date.parse(b.LastUpdated))
                    return 1;
                return 0;
            });
        },
        setupListnerInfo(log) {
            const groupedByName = this.groupBy(log.Hits, "Name");
            log.listenersInfo = Object.keys(groupedByName).map((caller) => {
                const hits = groupedByName[caller];
                const latestDate = this.getLatestDate(hits);

                const groupedByCall = this.groupBy(hits, "CallUUID");
                let secondsListened = 0;

                Object.keys(groupedByCall).forEach((key) => {
                    const call = groupedByCall[key];

                    call.sort(
                        (a, b) => new Date(a.Timestamp) - new Date(b.Timestamp),
                    ).forEach((hit, index) => {
                        const nextHit = call[index + 1];

                        if (!nextHit) {
                            const savedCall = this.calls.find(
                                (c) => c.Call_UUID == call[0].CallUUID,
                            );

                            if (savedCall != null && savedCall.EndTime) {
                                const start = Date.parse(
                                    moment(hit.Timestamp).subtract(
                                        2,
                                        "seconds",
                                    ),
                                );
                                const end = Date.parse(
                                    moment(hit.Timestamp).add(2, "seconds"),
                                );
                                const calllog = savedCall.Logs.find(
                                    (l) =>
                                        l.RecordingURL == hit.Recording &&
                                        Date.parse(l.Timestamp) > start &&
                                        Date.parse(l.Timestamp) < end,
                                );

                                if (calllog != null) {
                                    const logIndex = savedCall.Logs.indexOf(
                                        calllog,
                                    );
                                    const endTime =
                                        logIndex + 1 == savedCall.Logs.length
                                            ? savedCall.EndTime
                                            : savedCall.Logs[logIndex + 1]
                                                  .Timestamp;

                                    //const diffInSeconds = (endTime - hit.Timestamp).TotalSeconds;

                                    const diffInSeconds =
                                        (new Date(endTime).getTime() -
                                            new Date(hit.Timestamp).getTime()) /
                                        1000;

                                    secondsListened += diffInSeconds;
                                } else {
                                    secondsListened += 90;
                                }
                            } else {
                                secondsListened += 90;
                            }
                        } else {
                            const diffInSeconds =
                                (new Date(nextHit.Timestamp).getTime() -
                                    new Date(hit.Timestamp).getTime()) /
                                1000;

                            secondsListened += diffInSeconds;
                        }
                    });
                });

                let duration = moment("2015-01-01")
                    .startOf("day")
                    .seconds(secondsListened)
                    .format("H:mm:ss");

                return {
                    caller,
                    duration,
                };
            });
        },
        onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        },
        groupBy(list, key) {
            return list.reduce(function(rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        },
        getLatestDate(hits) {
            return new Date(
                Math.max.apply(
                    null,
                    hits.map(function(e) {
                        return new Date(e.Timestamp);
                    }),
                ),
            );
        },
        getDomain() {
            return window.location.origin.startsWith("http://localhost:8081") ||
                window.location.origin.startsWith("http://localhost:8080")
                ? "https://localhost:44337"
                : window.location.origin;
        },
        formatTime(date) {
            return moment(date).format("MM/DD/YYYY h:mm:ss A");
        },
        closeLogDetails() {
            this.viewLogDialog = false;
            this.clickedLog = "";
        },
        formatPhoneNumber(phoneNumberString) {
            phoneNumberString =
                phoneNumberString.length == 11
                    ? phoneNumberString.substr(-10)
                    : phoneNumberString;

            var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
            var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                return "(" + match[1] + ") " + match[2] + "-" + match[3];
            }
            return null;
        },
        getTypeIcon(type) {
            switch (type) {
                case "TALK":
                    return "mdi-voice";
                case "INTERVIEW":
                    return "mdi-account-switch";
                case "NEW_INTERVIEW":
                    return "mdi-microphone";
                case "STATES":
                    return "mdi-city";
            }
        },
        getTypeIconColor(type) {
            switch (type) {
                case "TALK":
                    return "#13a0eb";
                case "INTERVIEW":
                    return "#fdb400";
                case "NEW_INTERVIEW":
                    return "#eb3468";
                case "STATES":
                    return "#66bb6a";
            }
        },
        async viewDetails(item) {
            this.clickedLog = item;

            this.viewLogDialog = true;
            try {
                //this.setupListnerInfo(this.clickedLog);
                this.loading = true;

                if (
                    item.Hits &&
                    item.Hits.length &&
                    ["STATES", "NEW_INTERVIEW"].includes(item.Type)
                ) {
                    let url =
                        "https://broadcastmessageswercber.azurewebsites.net/api/broadcast/GetListenersSql?recordingURL=" +
                        item.Hits[0].Recording;

                    // if (item.Type != "STATES") {
                    //     url += "&type=" + item.Type.toLowerCase();
                    // }

                    const response = await this.$http.get(url);

                    this.clickedLog.listenerInfoSql = response.data.listeners;
                    this.loading = false;
                }
            } catch (e) {
                this.loading = false;
            }
        },
    },
};
</script>
<style>
tbody tr:nth-child(even) {
    background-color: #eee;
}
.row-height.v-list__tile theme--light {
    min-height: 75px !important;
    height: 75px !important;
}
</style>
